import resolutionCenterLabels from '../../../lib/resolutionCenterLabels';
import Page from '../../../lib/page';
import i18n from '../../../lib/reacti18n';
import { contactChannels } from '../../../common/commonConstants';
import {
  getMessageCenterUrl,
  getResolutionCenterUrl,
} from '../../../lib/globalHelper';

const isSmcEnabled = Page.getIsSmcEnabled();
const isLoggedIn = Page.isLoggedIn();

// Checking for contact card condition to display
const contactCardDisplay = {
  community: !!Page.getCommunityLink(),
  resolutionCenter: !!Page.getResolutionURL(),
  messageCenter: (isSmcEnabled || !isLoggedIn),
};

const labels = {
  resolutionLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.largeScreen'),
  communityLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.community.largeScreen'),
  communityLabel: i18n.message('smarthelp/contactLinksOption.message.community'),
  emailLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.email.largeScreen'),
  messageLabel: i18n.message('smarthelp/contactLinksOption.message.newMessageLabel'),
};

const contactCardUtils = [
  {
    contactType: contactChannels.RESOLUTION,
    contactLabel: labels.resolutionLargeScreen,
    contactDescription: resolutionCenterLabels(),
    contactDisplay: contactCardDisplay.resolutionCenter,
    contactTarget: '_blank',
    contactUrl: getResolutionCenterUrl(),
    contactSize: 'sm',
  },
  {
    contactType: contactChannels.COMMUNITY,
    contactLabel: labels.communityLargeScreen,
    contactDescription: labels.communityLabel,
    contactDisplay: contactCardDisplay.community,
    contactTarget: '_blank',
    contactUrl: Page.getCommunityLink(),
    contactSize: 'sm',
  },
  {
    contactType: contactChannels.MESSAGE_CENTER,
    contactLabel: labels.emailLargeScreen,
    contactDescription: labels.messageLabel,
    contactDisplay: contactCardDisplay.messageCenter,
    contactTarget: '_blank',
    contactUrl: getMessageCenterUrl(),
    contactSize: 'sm',
  },
];

export default contactCardUtils;
